exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".report-card-heading {\n  display: none;\n}\n@media print {\n.navbar,\n  .report-card-filter-div,\n  .report-card-btn {\n    display: none;\n}\n.report-card-heading {\n    display: block;\n}\n* {\n    -webkit-print-color-adjust: exact !important; /* Chrome, Safari 6 – 15.3, Edge */\n    color-adjust: exact !important; /* Firefox 48 – 96 */\n            print-color-adjust: exact !important; /* Firefox 97+, Safari 15.4+ */\n}\n}\n.schedule-time-div input.vdatetime-input {\n  width: 100%;\n  height: 100%;\n}\n", ""]);

// exports
